import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

export default createReducer(false, {

    [actions.TOGGLE_LABELS]: (state, action) => !state

})



// WEBPACK FOOTER //
// ./src/reducers/showLabels.js